import { ConfigSolicitacaoCirurgia } from '@/components/Configuracoes/store/ConfigSolicitacaoCirurgiaStore'
import HonorarioAnestesistaEnum from '@/types/enum/HonorarioAnestesistaEnum'

// Regra de configuração por hospital (template de solicitação de cirurgia): quando "Anestesista do
// hospital" (anestesiaDoHospital) é respondido como "Sim", o repasse do anestesista já é sabidamente
// do Hospital — se o hospital habilitar essa opção, o campo "Repasse anestesista" (honorarioAnestesista)
// deixa de ser perguntado e o valor é setado automaticamente. Usado tanto na solicitação (view) quanto
// na alteração de solicitação (backoffice), por isso a regra fica aqui em vez de duplicada nas duas telas.

export type AnestesiaDoHospital = string | null

type FormularioComHonorarioAnestesista = Pick<ConfigSolicitacaoCirurgia, 'honorarioAnestesista'> | undefined

function travaDeRepasseComoHospitalHabilitada(formulario: FormularioComHonorarioAnestesista): boolean {
  return !!(formulario && formulario.honorarioAnestesista && formulario.honorarioAnestesista.automatizadoQuandoAnestesiaEhDoHospital)
}

function deveBloquearRepasseAnestesistaComoHospital(anestesiaDoHospital: AnestesiaDoHospital, travaHabilitada: boolean): boolean {
  return !!travaHabilitada && anestesiaDoHospital === 'Sim'
}

// Decide o novo valor de honorarioAnestesista ao mudar anestesiaDoHospital: força "Hospital" se a trava
// passou a valer agora, limpa (string vazia) se a trava valia antes e deixou de valer, ou null se nada
// precisa mudar — quem chama só grava o campo quando o retorno não é null, preservando o valor atual.
function resolverNovoHonorarioAnestesista(params: {
  anestesiaDoHospital: AnestesiaDoHospital,
  anestesiaDoHospitalAnterior: AnestesiaDoHospital,
  formulario: FormularioComHonorarioAnestesista,
}): string | null {
  const travaHabilitada = travaDeRepasseComoHospitalHabilitada(params.formulario)

  if (deveBloquearRepasseAnestesistaComoHospital(params.anestesiaDoHospital, travaHabilitada)) {
    return HonorarioAnestesistaEnum.Hospital
  }

  if (deveBloquearRepasseAnestesistaComoHospital(params.anestesiaDoHospitalAnterior, travaHabilitada)) {
    return ''
  }

  return null
}

export {
  travaDeRepasseComoHospitalHabilitada,
  deveBloquearRepasseAnestesistaComoHospital,
  resolverNovoHonorarioAnestesista,
}
